import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';

const tripSlice = createSlice({
  name: 'trip',
  initialState: {
    tripData: null,
    loading: false,
    error: null,
  },
});

export const {
} = tripSlice.actions;

export default tripSlice.reducer;
